import { render, staticRenderFns } from "./SidebarCompany.vue?vue&type=template&id=235a618a&scoped=true&"
import script from "./SidebarCompany.vue?vue&type=script&lang=js&"
export * from "./SidebarCompany.vue?vue&type=script&lang=js&"
import style0 from "./SidebarCompany.vue?vue&type=style&index=0&id=235a618a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235a618a",
  null
  
)

export default component.exports